// extracted by mini-css-extract-plugin
export default {"text":"TableText_text__D2Cqm","bold":"TableText_bold__WeO6B","light":"TableText_light__wsKT2"};